import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.CHIP}/v1/equipment`;

async function create(payload) {
  try {
    let response = await api.post(basePath, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "equipmentService.create"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "equipmentService.create");
    return null;
  }
}

async function update(payload) {
  try {
    let response = await api.put(basePath, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "equipmentService.update"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "equipmentService.update");
    return null;
  }
}

async function save(payload) {
  if (payload.id > 0) {
    payload.equipmentId = payload.id;
    delete payload.id;
    await update(payload);
    return payload.id;
  }
  return await create(payload);
}

async function searchBySerial(serial) {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    serial: serial,
  };

  try {
    let response = await api.post(`${basePath}/serial`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.searchBySerial"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.searchBySerial");
    return null;
  }
}

async function searchByLineNumber(lineNumber) {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    lineNumber: lineNumber,
  };

  try {
    let response = await api.post(`${basePath}/lineNumber`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.searchByLineNumber"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.searchByLineNumber");
    return null;
  }
}

async function listModels() {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    name: -1,
  };

  try {
    let response = await api.post(`${basePath}/model`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.listModels"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.listModels");
    return null;
  }
}

async function listAccredited() {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    name: -1,
  };

  try {
    let response = await api.post(`${basePath}/accredited`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.listAccredited"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.listAccredited");
    return null;
  }
}

async function listStatus() {
  var payload = {
    pageSize: 500,
    pageNumber: 1,
    name: -1,
  };

  try {
    let response = await api.post(`${basePath}/status`, payload);
    let treated = errorHandling.handleResponse(
      response,
      "chipService.listStatus"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "chipService.listStatus");
    return null;
  }
}

export const equipmentService = {
  save,
  searchByLineNumber,
  searchBySerial,
  listModels,
  listAccredited,
  listStatus,
};
